import React, { createContext, useState } from "react";

export const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
  const [isToastActive, setIsToastActive] = useState(false);

  const handleToastState = (state) => {
    setIsToastActive(state);
  };

  return (
    <ToastContext.Provider value={{ isToastActive, handleToastState }}>
      {children}
    </ToastContext.Provider>
  );
};
